export default "__VITE_ASSET__CNDr7izt__"